import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push as pushAction } from 'react-router-redux';
import { Grid } from 'react-bootstrap';
import { isEqual, pick } from 'lodash';
import { Pagination } from '@components/common';
import AppActions from '@redux/app';
import { thunks } from '@redux/jobs';
import JobsWrapper from './components/jobsWrapper';
import Header from './components/header';
import Table from './components/table';
import EstimatesTable from './components/table/estimatesTable';

class List extends JobsWrapper {
	componentDidMount = () => {
		this.componentDidMountAddOn();
	};

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		/**
		 * Execute the UNSAFE_componentWillReceivePropsAddOn
		 * to process any possible
		 * updates
		 */

		this.UNSAFE_componentWillReceivePropsAddOn(nextProps);
	};

	shouldComponentUpdate = ({
		jobs, totalCount, filter, loadingJobs, loadingJobEstimates, activePage,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(activePage, lastProps.activePage)
			|| !isEqual(jobs, lastProps.jobs)
			|| !isEqual(totalCount, lastProps.totalCount)
			|| !isEqual(filter, lastProps.filter)
			|| !isEqual(loadingJobs, lastProps.loadingJobs)
			|| !isEqual(loadingJobEstimates, lastProps.loadingJobEstimates)
		);
	};

	applyFilter = (property) => (value) => this.props.applyCriteria([{ property, value }]);

	updateJobsPage = () => {
		const { getJobs, getCounts } = this.props;
		getJobs();
		getCounts();
	}

	render() {
		const {
			jobs,
			jobEstimates,
			totalCount,
			loadingJobs,
			loadingJobEstimates,
			filter : {
				displayCount,
				pageNumber,
			},
			activePage,
			timeZone,
			push,
		} = this.props;

		return (
			<React.Fragment>
				<Header
					activePage={activePage}
					pageName={activePage === 'needApproval' ? 'Estimates ' : 'Jobs'}
					hideDateRange={activePage === 'needApproval'}
				/>
				<Grid>
					<Choose>
						<When condition={activePage === 'needApproval'}>
							<EstimatesTable
								rows={jobEstimates}
								loading={loadingJobEstimates}
								timeZone={timeZone}
								updateJobsPage={this.updateJobsPage}
								push={push}
							/>
						</When>
						<Otherwise>
							<Table
								rows={jobs}
								loading={loadingJobs}
							/>
						</Otherwise>
					</Choose>
					<Pagination
						disabled={loadingJobs || loadingJobEstimates}
						totalCount={totalCount}
						displayCount={displayCount}
						pageNumber={pageNumber}
						onPaginate={this.applyFilter('pageNumber')}
						onDisplayCountChange={this.applyFilter('displayCount')}
					/>
				</Grid>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ({
	router : {
		location : { pathname },
	},
	app: { user : { TimeZoneId : timeZone } },
	jobs : {
		jobs,
		jobEstimates,
		totalCount,
		loaders : {
			jobs : loadingJobs,
			jobEstimates : loadingJobEstimates,
		},
		filter  : {
			displayCount,
			pageNumber,
		},
	},
}) => ({
	jobs,
	jobEstimates,
	totalCount,
	loadingJobs,
	loadingJobEstimates,
	timeZone,
	filter : {
		displayCount,
		pageNumber,
	},
	activePage : pathname.split('/')[3],
});

const mapDispatchToProps = (dispatch) => ({
	updateActiveLink : bindActionCreators(AppActions, dispatch).updateActiveLink,
	push             : bindActionCreators(pushAction, dispatch),
	...pick(bindActionCreators(thunks, dispatch), ['processUrl', 'applyCriteria', 'getJobs', 'getCounts']),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
